import React, { useEffect, useState } from "react"
import { ConfigProvider, Modal, theme } from "antd"
import { deleteBannerBot, getDeleteCalculation } from "../../services/bannerBotApis"
import { toast } from "react-toastify"

const DeleteModal = ({ botId }) => {
    const [calculation, setCalculation] = useState({})
    const [isOpen, setIsOpen] = useState(false)

    const toggleModal = () => setIsOpen(!isOpen)

    useEffect(() => {
        if (isOpen) {
            getDeleteCalculation(botId).then(({ data }) => {
                setCalculation(data)
            })
        }
    }, [isOpen])

    return (
        <>
            <button
                onClick={toggleModal}
                style={{ backgroundColor: "#EF4444" }}
                className="flex justify-center gap-2 border  text-white rounded-3xl px-4 py-1 m-2 transition duration-500 ease select-none hover:bg-red-600 focus:outline-none focus:shadow-outline"
            >
                <img src="assets/icons/trash-can.svg" width="20px" height="20px" />
                حذف
            </button>
            <ConfigProvider direction="rtl" theme={{ algorithm: theme.darkAlgorithm }}>
                <Modal
                    title="حذف بات بنر داینامیک با بنر ها"
                    open={isOpen}
                    onCancel={toggleModal}
                    onOk={() => {
                        toggleModal()
                        toast.promise(deleteBannerBot(botId), {
                            pending: "درحال حذف",
                            success: "حذف شد",
                        })
                        // submitHandler.delBanner(banner.id)
                    }}
                    okText={"حذف"}
                    cancelText={"بیخیال!"}
                    okType="danger"
                    okButtonProps={{ type: "primary" }}
                    footer={(_, { OkBtn, CancelBtn }) => (
                        <>
                            <div className="flex justify-between mx-2">
                                <div>مجموع: {calculation?.remainedPrice?.toLocaleString("en-US")} تومان</div>
                                <div className="flex gap-2">
                                    <CancelBtn />
                                    <OkBtn />
                                </div>
                            </div>
                        </>
                    )}
                >
                    <>
                        <div className="bg-stone-800 mt-5 p-2 border-sky-500 border-2 rounded-md max-h-96 overflow-y-auto">
                            <div>
                                {calculation &&
                                    calculation.calculationDescription?.map(({ type, line }, index) =>
                                        type == "info" ? (
                                            <div key={index} className="flex justify-center text-blue-500">
                                                {line}
                                            </div>
                                        ) : (
                                            <div key={index} className="text-green-500">
                                                {line}
                                            </div>
                                        ),
                                    )}
                            </div>
                        </div>
                    </>
                </Modal>
            </ConfigProvider>
        </>
    )
}

export default DeleteModal
